import { gql } from '@apollo/client'

export default gql`
  fragment ContractChange on Change {
    id
    changes
    validFrom
    status
    updatedDate
  }
`
